import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { deviceName } from '../../lib/assets';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Whether the label on the device has been checked, and the button that
 * checks it. Prominent only when the page was opened by scanning the label,
 * which is the one moment the person is standing in front of the device.
 * Moved here unchanged from pages/AssetDetail.js in the page redesign.
 */
export default function LabelCheck({ asset, scanned, onDone }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const confirm = async () => {
    setBusy(true);
    setError('');
    try { await axios.post(`${API_BASE}/assets/${asset.id}/confirm-tag`, {}); onDone(); } catch (e) {
      setError(e.response?.data?.error || 'Could not confirm the label.');
    } finally { setBusy(false); }
  };
  const confirmed = Boolean(asset.tag_confirmed_at);
  if (confirmed && !scanned) {
    return (
      <p className="as-quiet as-label-checked">
        {`Label checked on ${new Date(asset.tag_confirmed_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}. `}
        <Link to={`/assets/labels?ids=${asset.id}`}>Print it again</Link>
      </p>
    );
  }
  return (
    <div className="as-note" data-tone={scanned && !confirmed ? 'warning' : undefined} data-testid="label-check">
      {scanned
        ? <p style={{ margin: 0 }}>{`You scanned ${asset.asset_tag}. Is that label on this ${deviceName(asset)}${asset.serial_number ? `, serial ${asset.serial_number}` : ''}?`}</p>
        : <p style={{ margin: 0 }}>The label on this device has not been checked yet.</p>}
      {error && <p className="as-error" role="alert">{error}</p>}
      <div className="as-actions" style={{ margin: '0.6rem 0 0' }}>
        <button type="button" className="btn btn-primary btn-small" disabled={busy} onClick={confirm}>
          {confirmed ? 'Yes — check it again' : 'Yes, the label is on this device'}
        </button>
        <Link className="btn btn-plain btn-small" to={`/assets/labels?ids=${asset.id}`}>Print its label</Link>
      </div>
    </div>
  );
}
